import React from 'react';
import { Link } from 'react-router-dom';
import gridxMeter from '../../assets/gridx-meter.png';

const ConnectivitySection = () => (
  <section className="gh-section gh-connect">
    <div className="gh-section__inner gh-connect__grid">
      <div className="gh-connect__text">
        <span className="eyebrow">Smart energy. Complete connectivity.</span>
        <h2 className="gh-section__title">One device. Two revolutions.</h2>
        <p className="gh-connect__body">
          GRIDx is a revolutionary electric pre-paid smart meter that incorporates a
          Wi-Fi router, designed to solve the challenges of smart metering and internet
          connectivity in Africa. Our device combines advanced smart metering
          capabilities with cutting-edge telecommunication technologies, enabling homes
          to access Wi-Fi through various wireless options, including 4G, 3G, and fibre
          to the home (FTTH).
        </p>
        <p className="gh-connect__body">
          By seamlessly integrating with cellular or fibre networks, the GRIDx meter
          offers high-speed, reliable internet access to every home, bringing the
          benefits of the digital age to all residents.
        </p>
        <Link to="/gridx" className="btn btn--outline-light">
          Learn More About GRIDx
        </Link>
      </div>
      <div className="gh-connect__visual">
        <img
          className="gh-connect__meter"
          src={gridxMeter}
          width="291"
          height="291"
          alt="GRIDx smart meter device"
          loading="lazy"
          decoding="async"
        />
        <span className="gh-connect__caption">
          <span className="gh-connect__dot" />
          GRIDx Smart Meter
        </span>
      </div>
    </div>
  </section>
);

export default ConnectivitySection;
